import { render, staticRenderFns } from "./CreateOrganizationFromContactModal.vue?vue&type=template&id=142e80e5&"
import script from "./CreateOrganizationFromContactModal.vue?vue&type=script&lang=js&"
export * from "./CreateOrganizationFromContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports